import { Component, OnInit } from '@angular/core';
import { Field } from '../../models/field.interface';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Masks } from '@core/custom-validators/masks';
import { FieldConfig } from '../../models/field-config.interface';
import { CustomValidators } from '@core/custom-validators/validators';

@Component({
  selector: 'app-form-chassi',
  templateUrl: './form-chassi.component.html',
  styleUrls: ['./form-chassi.component.scss']
})
export class FormChassiComponent implements Field, OnInit {
  formChassi: FormGroup;
  config: FieldConfig;
  group: FormGroup;
  mask = {
    mask: Masks.chassi,
    guide: false,
    modelClean: true
  };
  firstSubmit: boolean;

  constructor(private formBuilder: FormBuilder) { }

  ngOnInit() {

    this.formChassi = this.formBuilder.group({
      chassi: ['']
    })

    if (this.config.required) {
      this.chassi.setValidators(Validators.compose([Validators.required, Validators.minLength(17), CustomValidators.chassi]))
      this.chassi.updateValueAndValidity()
    }
    else
      this.chassi.setValidators(Validators.compose([CustomValidators.chassi]))

    this.group.statusChanges.subscribe((val) => {
      if (!this.firstSubmit) {
        this.firstSubmit = true;
        this.chassi.setValue(this.chassi.value);
      }
    })

    this.chassi.valueChanges.subscribe((val) => {

      if (this.chassi.valid) {
        this.control.setValue(this.clearMaskValue(val));
      }
      else {
        this.control.setValue(undefined);
      }
      
    })
  }

  get chassi() {
    return this.formChassi.controls.chassi;
  }

  get control() {
    return this.group.controls[this.config.name];
  }

  clearMaskValue(val): string {
    if (val)
      return val.replace(/[^\w\s]/gi, '');

    return val;
  }
}
